import { type GetAlgoliaInsightsProps } from './types';

export const getAlgoliaInsights = () =>
  JSON.parse(
    localStorage.getItem('__algoliaInsights__') ?? 'null'
  ) as GetAlgoliaInsightsProps | null;
